// removed by extract-text-webpack-plugin
module.exports = {"subtitle":"Subtitle__subtitle___i7BYe"};